import _styled, { default as _styled2 } from "styled-components";
var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import * as styles from "./AccountPopover.styles";
export var AccountItem = function AccountItem(_ref) {
  var Icon = _ref.Icon,
    iconProps = _ref.iconProps,
    text = _ref.text;
  return /*#__PURE__*/React.createElement(_StyledSpan, {
    $_css: [styles.accountItem]
  }, Icon && iconProps && /*#__PURE__*/React.createElement(_StyledSpan2, {
    $_css2: styles.accountItemIconContainer
  }, /*#__PURE__*/React.createElement(Icon, iconProps)), text);
};
var _StyledSpan = _styled("span")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css;
});
var _StyledSpan2 = /*#__PURE__*/_styled2("span").withConfig({
  displayName: "AccountItem___StyledSpan2",
  componentId: "sc-1poiinb-0"
})(["", ""], function (p) {
  return p.$_css2;
});